import { render, staticRenderFns } from "./EmailResponses.vue?vue&type=template&id=bc80da96&scoped=true"
import script from "./EmailResponses.vue?vue&type=script&lang=js"
export * from "./EmailResponses.vue?vue&type=script&lang=js"
import style0 from "./EmailResponses.vue?vue&type=style&index=0&id=bc80da96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc80da96",
  null
  
)

export default component.exports